import { render, staticRenderFns } from "./AutoLoadable.vue?vue&type=template&id=bd7e123a&"
import script from "./AutoLoadable.vue?vue&type=script&lang=ts&"
export * from "./AutoLoadable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports